import { render, staticRenderFns } from "./VideoPreview.vue?vue&type=template&id=a8e5bb92&"
import script from "./VideoPreview.vue?vue&type=script&lang=ts&"
export * from "./VideoPreview.vue?vue&type=script&lang=ts&"
import style0 from "./VideoPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports